import { render } from "./GlobalNavComponent.vue?vue&type=template&id=46d15c74&scoped=true&ts=true"
import script from "./GlobalNavComponent.vue?vue&type=script&lang=ts"
export * from "./GlobalNavComponent.vue?vue&type=script&lang=ts"

import "./GlobalNavComponent.vue?vue&type=style&index=0&id=46d15c74&lang=css"
import "./GlobalNavComponent.vue?vue&type=style&index=1&id=46d15c74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46d15c74"]])

export default __exports__